import DetailModal from './detail-modal';

export default DetailModal;
